import React from 'react'
import { MoonLoader } from 'react-spinners'

const Index = () => {
    return(
        <div className="loading-container">
            <div className="loader">
                <MoonLoader size={30} color={"#123abc"} loading={true} css={`margin: 0 auto;`}/>
            </div>
            <h3 className="loading-title">Setter opp abonnement..</h3>
            <p className="loading-description">Vennligst vent mens vi verifiserer betalingen og setter opp et miljø, dette tar bare noen få sekunder.</p>
        </div>
    )
}

export default Index